<template>
  <div class="four-intro">
    <p>
      <span class="caps">V</span>ous retournez chez votre voisine en fin de journée. Vous vous demandez quel
      moyen Carmen va utiliser pour rentrer en communication avec les esprits cette fois-ci.
      Vous frappez à la porte et Carmen vous indique que vous pouvez entrer. Elle est attablée,
      occupée à mélanger un jeu de tarot divinatoire fort usé. Le tirage des cartes est l'une de ses
      grandes spécialités !
    </p>
  </div>
</template>
<script>
export default {
  name: "FourIntro"
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.four-intro {
  padding: 10% 18%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 80%;
}
.caps {
  color: rgba(0, 0, 0, 0.7);
  float: left;
  font-size: 110px;
  line-height: 0.8em;
  padding-right: 12px;
  position: relative;
  top: 8px;
}
</style>